import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import PageHero from '../components/layout/PageHero';
import TrendingSection from '../components/trending/TrendingSection';
import { ChevronRight } from 'lucide-react';
import { SIMULATOR_CATALOG, simulatorToTrendingItem } from '../lib/simulationCatalog';

const SimulatorCard = ({ icon: Icon, title, to, description }) => (
  <Link to={to} data-testid={`simulator-card-${to.split('/').pop()}`}>
    <Card className="technical-card h-full">
      <CardContent className="p-6 flex flex-col h-full">
        <div className="h-10 w-10 rounded-md bg-chassis flex items-center justify-center mb-4">
          <Icon className="h-5 w-5 text-autoxium-blue" />
        </div>
        <h3 className="font-chivo text-lg font-bold uppercase tracking-tight mb-2">{title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed flex-1">{description}</p>
        <div className="flex items-center gap-1 text-xs font-mono uppercase tracking-wider text-autoxium-blue mt-4">
          Open Simulator <ChevronRight className="h-3.5 w-3.5" />
        </div>
      </CardContent>
    </Card>
  </Link>
);

const SimulationPage = () => {
  const trendingSimulatorItems = useMemo(() => SIMULATOR_CATALOG.map(simulatorToTrendingItem), []);

  return (
    <div className="min-h-screen" data-testid="simulation-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Simulation"
        description="Full-fidelity simulators for vehicle performance/range and EV charging behavior — beyond what a single closed-form calculator can capture."
        testId="simulation-hero"
      />

      <TrendingSection sectionType="simulation" items={trendingSimulatorItems} />

      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SIMULATOR_CATALOG.map((sim) => (
              <SimulatorCard key={sim.to} {...sim} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SimulationPage;
